import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
    name: 'displaySchemaFilter',
    standalone: false
})
export class SchemaFilterPipe implements PipeTransform {

    transform(values: Array<any>, searchSchemaText: string): any[] {
        return values?.filter(project =>
            project.name.toLowerCase().indexOf(searchSchemaText?.toLowerCase()) !== -1
            || project.key.toLowerCase().indexOf(searchSchemaText?.toLowerCase()) !== -1)
    }

}